import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex gap-3 selection-cards" }
const _hoisted_2 = ["data-card-type", "data-card-value", "data-theme-card", "data-layout-card", "onClick"]
const _hoisted_3 = {
  key: 1,
  class: "lang-flag"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
      return (_openBlock(), _createElementBlock("label", {
        key: option.value,
        class: _normalizeClass([$props.cardClass, { active: $setup.activeValue === option.value }]),
        "data-card-type": $props.cardType,
        "data-card-value": option.value,
        "data-theme-card": $props.cardType === 'theme' ? option.value : undefined,
        "data-layout-card": $props.cardType === 'layout' ? option.value : undefined,
        onClick: _withModifiers($event => ($setup.selectCard(option.value)), ["prevent"])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([$props.innerClass, option.innerClass])
        }, [
          (option.icon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass([option.icon, 'fa-2x', 'mb-2'])
              }, null, 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (option.flag)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(option.flag), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", null, _toDisplayString(option.label), 1 /* TEXT */)
        ], 2 /* CLASS */)
      ], 10 /* CLASS, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}